export default {
	compMst: [],
	gridList: [],
	useYnList: [], //사용여부
	PartTypeList: [], //부품유형
	cpnyScnList: [], //업체구분
	ssClassList: [], //서비스센터 class
	getUserNameList: [], //업체담당자
	searchParams: SEARCH_PARAMS(), //조회조건 파라미터
	groups: GROUPS(), //페이징처리
	masterInfo: MASTER_INFO()
};

function GROUPS() {
	return {
		currentPage: 1,
		pageUnit: 30,
		totalSize: 0
	};
}
function SEARCH_PARAMS() {
	return {
		cpnyScn: '',
		cpnyNm: '',
		useYn: 'Y'
	};
}

function MASTER_INFO() {
	return {
		readOnlyAuth: true, //신규 권한
		cpnyScn: '',
		cpnyCd: '',
		cpnyNm: '',
		crgrNm: '',
		userName: '',
		partType: '',
		crgrTn: '',
		eml: '',
		fax: '',
		regn: '',
		adr: '',
		useYn: '',
		sortNo: '',
		custProdNo: '',
		ssClass: '',
		ssClassNm: ''
	};
}
export { SEARCH_PARAMS, GROUPS, MASTER_INFO };
